/* eslint-disable */
// not using this anymore now that utc has offset from GMT accounted for
function getTimezoneOffsetFromGMT() {
    const offset = (new Date()).getTimezoneOffset() / 60;

    // American locations are east of GMT so default to negative
    let formattedOffset = '-';
    if (offset < 0) {
        formattedOffset = '+';
    }

    // pad the offset in the front with 0s if needed
    if (Math.abs(offset) >= 10) {
        return `${formattedOffset}${offset}00`;
    }
    return `${formattedOffset}0${offset}00`;
}
/* eslint-enable */

export default function getMinutesUntilStart({ utc }, targetDate = new Date()) {
    const now = targetDate.getTime();
    const eventTime = (new Date(utc)).getTime();

    return Math.floor(((eventTime - now) / 1000) / 60);
};



// WEBPACK FOOTER //
// ./app/lib/format/getMinutesUntilStart.js